export default __webpack_public_path__ + "static/media/SelflessLeadership.ae13af38.jpeg";